module.exports = __webpack_public_path__ + "img/laundry-no.8ad5e139.svg";